import Typography from '@mui/material/Typography';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { FieldsetBox, LegendStyled } from '../styling/StyledComponents';

const dayChoices = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

export default function DayofweekFilter(props) {
  const { userParams, setUserParams } = props;

  const handleChange = (event, newvals) => {
    setUserParams({...userParams, weekdays:newvals});
  };

  return (
    <FieldsetBox component="fieldset">
      <LegendStyled>Day of week filter</LegendStyled>
      <Typography variant="body2" sx={{ mb: 1, fontStyle: 'italic' }}>
        For each week, use highlighted days:
      </Typography>

      <ToggleButtonGroup
        value={userParams.weekdays}
        onChange={handleChange}
      >
        { dayChoices.map((wd,i) => (
          <ToggleButton key={i} value={i}>
            {wd}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </FieldsetBox>
  )
}